// MemberRedirect — PUBLIC safe-redirect screen for a carrier portal link
// (/member/<token>). Resolves the token to the current official carrier URL and
// shows a safety interstitial before sending the consumer to the carrier site.
// No auth; no consumer data in the URL.

import React from 'react';

const font = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";

export default function MemberRedirect({ token }) {
  const [state, setState] = React.useState('loading');
  const [d, setD] = React.useState(null);
  React.useEffect(() => { (async () => {
    const r = await fetch(`/api/public/member-redirect?token=${encodeURIComponent(token)}`);
    const j = await r.json().catch(() => ({}));
    if (r.ok && j.target_url) { setD(j); setState('ready'); } else { setD(j); setState('error'); }
  })(); }, [token]);

  const wrap = (children) => <div style={{ minHeight: '100vh', background: '#F4F7FA', fontFamily: font, display: 'grid', placeItems: 'center', padding: 20 }}>
    <div style={{ background: '#fff', borderRadius: 18, padding: '30px 26px', maxWidth: 420, width: '100%', boxShadow: '0 30px 60px -30px rgba(15,40,55,0.25)', color: '#0B2233' }}>{children}</div>
  </div>;

  if (state === 'loading') return wrap(<div style={{ textAlign: 'center', color: '#64748B' }}>Loading…</div>);
  if (state === 'error') return wrap(<div style={{ textAlign: 'center' }}>
    <div style={{ fontSize: 32, marginBottom: 10 }}>🔗</div>
    <h1 style={{ fontSize: 19, margin: '0 0 8px' }}>This link isn't available</h1>
    <p style={{ color: '#4A5D6B', fontSize: 14, lineHeight: 1.55 }}>{d?.carrier_name ? `The ${d.carrier_name} link may have changed.` : 'This link may have expired.'} Please contact your agent for an updated link.</p>
  </div>);

  return wrap(<div style={{ textAlign: 'center' }}>
    <div style={{ fontSize: 30, marginBottom: 10 }}>🔒</div>
    <h1 style={{ fontSize: 20, margin: '0 0 8px' }}>You're leaving Six Figure Agent OS</h1>
    <p style={{ color: '#4A5D6B', fontSize: 14.5, lineHeight: 1.6, margin: '0 0 6px' }}>You're being taken to the official <b>{d.carrier_name}</b>{d.portal_name ? ` (${d.portal_name})` : ''} member website.</p>
    <p style={{ color: '#B45309', fontSize: 13, lineHeight: 1.55, margin: '0 0 20px', background: '#FEF6E7', border: '1px solid #F5D9A0', borderRadius: 10, padding: '10px 12px' }}>Never share your password or one-time security code with anyone.</p>
    <a href={d.target_url} rel="noreferrer" style={{ display: 'block', padding: '14px 0', borderRadius: 12, background: '#0E7C86', color: '#fff', fontWeight: 700, fontSize: 15.5, textDecoration: 'none' }}>Continue to {d.carrier_name}</a>
    <div style={{ fontSize: 11, color: '#8296A2', marginTop: 12, wordBreak: 'break-all' }}>{(d.target_url || '').replace(/^https?:\/\//, '').split('/')[0]}</div>
  </div>);
}
